import { z } from 'zod/v4';

export const BookmarkSchema = z.object({
  id: z.string(),
  url: z.url(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  userId: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type Bookmark = z.infer<typeof BookmarkSchema>;

export const CreateBookmarkSchema = z.object({
  url: z.url(),
  title: z.string().optional(),
  description: z.string().optional(),
});

export type CreateBookmark = z.infer<typeof CreateBookmarkSchema>;

export const UpdateBookmarkSchema = z.object({
  url: z.url().optional(),
  title: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
});

export type UpdateBookmark = z.infer<typeof UpdateBookmarkSchema>;

export const TagSchema = z.object({
  id: z.string(),
  name: z.string(),
  userId: z.string(),
  createdAt: z.date(),
});

export type Tag = z.infer<typeof TagSchema>;

export const CreateTagSchema = z.object({
  name: z.string().min(1).max(50),
});

export type CreateTag = z.infer<typeof CreateTagSchema>;

export const CollectionSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  userId: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type Collection = z.infer<typeof CollectionSchema>;

export const CreateCollectionSchema = z.object({
  name: z.string().min(1).max(100),
  description: z.string().optional(),
});

export type CreateCollection = z.infer<typeof CreateCollectionSchema>;

export const UpdateCollectionSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  description: z.string().nullable().optional(),
});

export type UpdateCollection = z.infer<typeof UpdateCollectionSchema>;
